'use client';

import { ReduxProvider } from './redux.wrapper';
import { Theme } from './theme.wrapper';

const Providers = ({ children, lang }: { children: React.ReactNode; lang: 'ar' | 'en' }) => {
  return (
    <Theme lang={lang}>
      <ReduxProvider>{children}</ReduxProvider>
    </Theme>
  );
};
export default Providers;
